export default __webpack_public_path__ + "static/media/board.min.9700d6f9.png";